<template>
    <div>
        <div class="card border-0 m-b-10">
            <div class="card-body">
                <div class="card-text">

                    <div class="row">
                        <div class="col-xl-6">
                            <div class="table-responsive form-inline">
                                <table class="table table-profile">
                                    <tbody>
                                    <tr v-for="(item,index) in contactsGet.contacts" :key="index">
                                        <td class="field" v-text="item.title"></td>
                                        <td><i :class="item.icon+' m-r-5'"></i><span v-text="item.value"></span></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <form>
                                <div class="form-group row m-b-15" :key="index"
                                     v-for="(item,index) in contactsGet.message">
                                    <label class="col-form-label col-md-3" v-text="item.title" :for="index"></label>
                                    <div class="col-md-9">
                                        <input v-if="item.inputType == 'input'" :type="item.type" :id="index" class="form-control m-b-5" :placeholder="item.placeholder">
                                        <textarea v-else-if="item.inputType == 'textarea'" :id="index" class="form-control" rows="3"></textarea>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: mapGetters(["contactsGet"]),
    }
</script>